.ux-guided-tour-overlay {
  display: block;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  z-index: var(--ux-guided-tour-overlay-z-index, 800);

  &.ux-guided-tour-overlay--ready {
    transition: opacity 0.2s ease-out;
  }

  &.ux-guided-tour-overlay--active {
    opacity: 1;
  }

  &__canvas {
    left: 0;
    opacity: 0.5;
    pointer-events: none;
    position: absolute;
    top: 0;
  }

  &__focus {
    pointer-events: none;
    position: absolute;
  }

  &__focus--highlight {
    box-shadow: 0 0 20px 5px var(--ux-guided-tour-overlay-glow-color);
    mix-blend-mode: screen;
  }

  &__focus--shadow {
    box-shadow: 0 0 20px 5px var(--ux-guided-tour-overlay-shadow-color);
  }

  &__buttons {
    margin-top: 20px;
    text-align: right;
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    flex-wrap: wrap;

    @media only screen and (min-width: $tablet) {
      justify-content: flex-end;
    }
  }

  &__steps {
    color: $color-gray-text;
    font-size: $size-text-small;
    line-height: 1;
    margin-bottom: 0.5em;
    margin-top: -0.5em;
  }

  .ux-popover__container {
    max-width: calc(100vw - 40px);
  }

  .ux-popover__overlay--opened {
    transition: opacity 200ms ease-out, transform 200ms ease-in-out;
  }

  .ux-popover-panel {
    border-radius: var(--ux-guided-tour-overlay-border-radius);
  }

  .ux-popover-panel {
    max-width: 100%;
    padding: 30px;
    width: 450px;

    h4,
    p {
      font-size: 16px;
      margin: 0 0 0.5em;
    }

    h4 {
      font-weight: 400;
    }

    .ux-button {
      height: var(--ux-button-min-height);
      min-height: var(--ux-button-min-height);
      padding-bottom: 0;
      padding-top: 0;
      vertical-align: top;
    }

    .ux-button:last-of-type {
      margin-left: 10px;
    }
  }
}

.ux-guided-tour-backdrop {
  display: block;
  height: auto;
  inset: 0;
  pointer-events: none;
  position: absolute;
  width: auto;

  &__blocker {
    pointer-events: auto;
    position: absolute;
  }
}

.ux-guided-tour-progress {
  bottom: 0;
  height: 4px;
  left: 0;
  position: absolute;
  width: 100%;

  &__bar {
    background-color: var(--ux-guided-tour-progress-bar-color);
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
  }
}
